module.exports = __webpack_public_path__ + "static/img/Store-5.f6440fcb.png";